import styled, { css } from 'styled-components'
import { Swiper } from 'swiper/react'
import { ArrowDownIcon } from '@velasca/icons/arrow-down'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'

export const Layout = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Slider = styled(Swiper)`
  margin: 0 auto;

  .swiper-pagination {
    margin-top: 2rem;

    @media screen and (min-width: 992px) {
      margin-top: 0;
    }
  }

  .swiper-pagination-bullet {
    margin: 0 0.3rem !important;
    width: 10%;
    max-width: 5rem;
    height: 0.3rem;
    border-radius: 0;
    background: ${({ theme }) => theme.colors.sliderActionButtonInactive};
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: ${({ theme }) => theme.colors.sliderActionButtonActive};
  }

  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
`

const ArrowIcon = styled(ArrowDownIcon)`
  width: 2rem;
  height: 2rem;
`

export const NavigationButton = styled.button`
  display: none;
  position: absolute;
  z-index: 10;

  &.right {
    right: 0;
  }

  &.left {
    left: 0;
  }

  @media screen and (min-width: 992px) {
    display: block;
    border: none;
    background: none;
    padding: 2rem;
    color: ${({ theme }) => theme.colors.sliderActionButtonInactive};

    &:hover {
      cursor: pointer;
      color: ${({ theme }) => theme.colors.sliderActionButtonActive};
    }
  }
`

export const ArrowLeftIcon = styled(ArrowIcon)`
  transform: rotate(90deg);
`

export const ArrowRightIcon = styled(ArrowIcon)`
  transform: rotate(-90deg);
`

export const Card = styled.div<{ isSingleSlide: boolean }>`
  @media screen and (min-width: 992px) {
    ${({ isSingleSlide }) => {
      return (
        isSingleSlide &&
        css`
          padding-left: calc(6rem + 1%);
          padding-right: calc(6rem + 1%);
        `
      )
    }}
  }
`

export const Image = styled(ResponsiveImage)`
  grid-area: Image;
  object-fit: cover;
  width: 100%;
  aspect-ratio: 4 / 5;

  .safari-lower-than-15 & {
    position: absolute;
    top: 0;
    height: 100%;
  }

  @media screen and (min-width: 992px) {
    aspect-ratio: 21 / 9;
  }
`

export const ButtonContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 30rem;
  width: 100%;
`
